import { Tab, Tabs } from "@mui/material";
import { useEffect, ReactNode, useState } from "react";

import Box from "../Box";
import Helpers from "../../commons/helpers";
import { useCommonComponentContext } from "../../providers/CommonComponentProvider";

interface Props {
    children?: ReactNode;
    defaultLanguage?: string;
    onChangeLanguage?: (value: string) => void;
}

const TabMultiLanguage: React.FC<Props> = (props: Props) => {
    const [value, setValue] = useState(0);
    const { listMultiLanguage } = useCommonComponentContext();

    useEffect(() => {
        if (Helpers.isNullOrEmpty(props.defaultLanguage)) {
            setValue(0);
        } else {
            const index = listMultiLanguage.findIndex(el => el.code === props.defaultLanguage);
            setValue(index);
        }
    }, [props.defaultLanguage]);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
        Helpers.isFunction(props.onChangeLanguage) && props.onChangeLanguage(`${listMultiLanguage[newValue].code}`);
    };

    return (
        <Box>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    value={value}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                    onChange={handleChange}
                >
                    {
                        listMultiLanguage.map((item, index: number) => (
                            <Tab key={`${item.code}_${index}`} label={item.name} />
                        ))
                    }
                </Tabs>
            </Box>
            {props.children}
        </Box>
    );
}

export default TabMultiLanguage;